module.exports = __webpack_public_path__ + "static/ch7-SCENE-12-March-e1c25a873405a530327b32f51aa0ee6d.mp4";